export default __webpack_public_path__ + "static/media/checkbox-checked.38b73c8b.svg";